import { message, Form, Input, Button, Select } from 'antd';
import contactApi from '../../api/contact';

const { Option } = Select;

/* eslint-disable no-template-curly-in-string */
const validateMessages = {
  required: '请填写${label}!',
  types: {
    email: '请填写有效${label}!',
  },
};
/* eslint-enable no-template-curly-in-string */

const ContactForm = () => {
  const onFinish = (values) => {
    if (!values.question) {
      values.question = '';
    }

    let data = { ...values, type: 1 };

    contactApi(data).then((res) => {
      if (res.status === 200) {
        message.success('已提交，我们会尽快联系您，谢谢。');
      } else {
        let error_msgs = '',
          msgs = res.data.msg;
        if (typeof msgs == 'object') {
          Object.keys(msgs).forEach((key) => {
            return (error_msgs += `${msgs[key]};`);
          });
        } else {
          error_msgs = msgs;
        }
        message.error(error_msgs);
      }
    });
  };

  return (
    <Form
      name="contentus-form"
      layout="vertical"
      onFinish={onFinish}
      validateMessages={validateMessages}
      size="large"
    >
      <Form.Item name="name" label="姓名" rules={[{ required: true }]}>
        <Input />
      </Form.Item>

      <Form.Item
        name="telephone"
        label="手机号码"
        rules={[
          { required: true },
          { pattern: /^1[345789]\d{9}$/, message: '请输入正确的手机格式' },
        ]}
      >
        <Input />
      </Form.Item>

      <Form.Item
        name="email"
        label="邮箱"
        rules={[{ required: true, type: 'email' }]}
      >
        <Input />
      </Form.Item>

      <Form.Item name="company" label="公司名称" rules={[{ required: true }]}>
        <Input />
      </Form.Item>

      <Form.Item name="company_scale" label="公司规模" placeholder="请选择">
        <Select allowClear>
          <Option value="0">1-2人</Option>
          <Option value="1">3-7人</Option>
          <Option value="2">8人或以上</Option>
          <Option value="3">暂无广告投放团队</Option>
        </Select>
      </Form.Item>

      <Form.Item name="question" label="你想要的咨询的问题">
        <Input.TextArea />
      </Form.Item>

      <Form.Item>
        <Button className="submitButton" type="primary" htmlType="submit">
          联系我们
        </Button>
      </Form.Item>
    </Form>
  );
};
export default ContactForm;
